import { observer } from 'mobx-react'
import React from 'react'
import i18n from 'i18next'

import Modal from '../../UniformComponents/Modal'
import Panel from '../../UniformComponents/Panel'
import Typography from '../../UniformComponents/Typography'

import './surveyLicenceModal.scss'

const SurveyLicenceModal = ({ store }) => (
    <Modal
        show={store.surveyLicenceModalVisible}
        onClose={store.closeSurveyLicenceModal}
        style={{ width: 500 }}
    >
        <Typography type="h2">
            {i18n.t('surveyLicenceModal.title')}
        </Typography>

        <Typography>
            {i18n.t('surveyLicenceModal.subtitle')}
        </Typography>

        <br />

        <br />

        <div className="licence-option-container">
            <Panel
                cssClass={`licence-option pro-option ${store.selectedSurveyLicense === 'pro' ? 'selected-licence' : ''}`}
                onClick={() => store.selectSurveyLicense('pro')}
            >
                <div className="icon-container green-container">
                    <i className="fal fa-clipboard-list clipboard-icon" />

                    <span className="pro-icon">
                        PRO
                    </span>
                </div>

                <br />

                <Typography type="h4">
                    {i18n.t('surveyLicenceModal.proOption')}
                </Typography>
            </Panel>

            <Panel
                cssClass={`licence-option lite-option ${store.selectedSurveyLicense === 'rapid' ? 'selected-licence' : ''}`}
                onClick={() => store.selectSurveyLicense('rapid')}
            >
                <div className="icon-container purple-container">
                    <i className="fal fa-clipboard-list-check clipboard-icon" />

                    <i className="fas fa-feather feather-icon" />
                </div>

                <br />

                <Typography type="h4">
                    {i18n.t('surveyLicenceModal.liteOption')}
                </Typography>
            </Panel>
        </div>
    </Modal>
)

export default observer(SurveyLicenceModal)
